import { generateUrlParams } from "../../utils/generateUrlParams";
const baseUrl = "JupebApplication";
export const verifyJupebApplicationStatusUrl = (rrr) =>
	`${baseUrl}/verify-application-status/${rrr}`;
export const previewJupebApplicationUrl = (rrr) =>
	`${baseUrl}/verify-and-load-jupeb-application-form/${rrr}`;
export const addAndUpdateJupebProfile = () =>
	`${baseUrl}/add-or-update-jupeb-application-form`;
export const addAndUpdateSponsorAndRefereeUrl = () =>
	`${baseUrl}/add-or-update-jupeb-application-sponsor-and-referee`;
export const addAndUpdateOLevelUrl = () =>
	`${baseUrl}/add-or-update-jupeb-application-olevel-details`;
export const uploadDocumentsUrl = (applicantId) =>
	`${baseUrl}/upload-documents/${applicantId}`;
export const getAllJupebApplicationsUrl = (filter) =>
	`${baseUrl}/all-jupeb-applications?${generateUrlParams(filter)}`;
export const changeJupebApplicationStatusUrl = (applicationNo) =>
	`${baseUrl}/admit-jupeb-applicant?regNumber=${applicationNo}`;

export const downloadJupebApplicationReportUrl = (filter) =>
	`${baseUrl}/download-jupeb-applications-report?${generateUrlParams(
		filter
	)}`;
export const getJupebApplicationReportUrl = (filter) =>
	`${baseUrl}/jupeb-application-report?${generateUrlParams(filter)}`;